var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9171 16.0833L25.1254 1.875M10.9171 16.0833L15.4379 25.125C15.4946 25.2487 15.5856 25.3535 15.7 25.4269C15.8145 25.5004 15.9477 25.5395 16.0837 25.5395C16.2198 25.5395 16.3529 25.5004 16.4674 25.4269C16.5819 25.3535 16.6729 25.2487 16.7296 25.125L25.1254 1.875M10.9171 16.0833L1.8754 11.5625C1.75173 11.5058 1.64693 11.4148 1.57346 11.3004C1.49999 11.1859 1.46094 11.0527 1.46094 10.9167C1.46094 10.7806 1.49999 10.6475 1.57346 10.533C1.64693 10.4185 1.75173 10.3275 1.8754 10.2708L25.1254 1.875",
    stroke: "#367FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.49e0aa6f5df082ef60329bd2c9a6a29d.svg";
export { ForwardRef as ReactComponent };